import { FileType } from '../../lib/types/models/file/file'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderDocuments(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getDocuments.url, { id }))
    .get<FileType[]>()
}
